<template>
      <div class="main-box main-content">
          <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" >
                <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="110px">
                     <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item  label="账号：" prop="id">
                              <el-input v-model="temp.loginName" :disabled="true" placeholder="请输入账号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="用户名称：" prop="userName">
                              <el-input v-model="temp.userName" placeholder="请输入用户名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="手机号：" prop="mobile">
                              <el-input v-model="temp.mobile" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="电子邮箱：" prop="email">
                              <el-input v-model="temp.email" placeholder="请输入电子邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                       <el-col :span="12">
                         <el-form-item  label="医生姓名：" >
                          <el-input v-model="temp.staffNickName" placeholder="" disabled></el-input>
                         </el-form-item>
                       </el-col>
                       <el-col :span="12">
                         <el-form-item  label="团队名称：">
                           <el-input v-model="temp.medicalTeamName" placeholder="" disabled></el-input>
                         </el-form-item>
                       </el-col>
                       <el-col :span="12">
                         <el-form-item  label="电子签名：">
                           <xr-upload-single-picture :resourceId="temp.electronicSignature"  @changeMethod="updateSignature"></xr-upload-single-picture>
                         </el-form-item>
                       </el-col>
                     </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                     <xr-button type="primary" @click.native="save('dataForm')">确定</xr-button>
                     <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
                </div>
          </el-dialog>
        <team-user-select ref="teamUserSelect" v-if="isTeamUserSelectShow" @confirmMethod="selectTeamUser"></team-user-select>
      </div>
</template>

<script>
  import request from "../utils/request";
  import TeamUserSelect from "./PageSelect/ph/teamUserSelect";

  export default {
    // userAdd
    name: 'baseInfo',
    data() {
      return {
        dialogVisible: false,
        validateIdVisible: true,
        dialogName: '基础信息',
        selectName: '',
        type: '',
        isTeamUserSelectShow: false,  //选择家医
        temp: {
            id: '',
            userName: '',
            mobile: '',
            email: '',
            electronicSignature: '',
            photo: '',
            phStaffCode: '',
            phStaffName: '',
            phTeamCode: '',
            phTeamName: '',
            staffNickName:'',
            medicalTeamName:''

        },
        rules: {
          userName: [
            { message: '用户名称不能为空!', required: true, trigger: 'blur' }
          ],

        }
      }
    },
    components: {
      TeamUserSelect
    },
    methods: {
      //初始化页面
      init(id) {
        this.dialogVisible = true;
        this.temp.id = id;
        this.type = 'edit'
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tCoreUser_getPageInfo',
            id: id,
            type: this.type
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(this.type === 'edit'){
            if(response.data ){
               if(response.data.info){
                 this.temp = response.data.info;
               }
               this.temp.staffNickName = response.data.staffNickName || this.temp.userName
               this.temp.medicalTeamName = response.data.medicalTeamName || this.temp.phTeamName
            }
          }
        })
      },
      updateSignature(resourceId){
        this.temp.electronicSignature = resourceId[0].id;
      },
      updatePhoto(resourceId){
        this.temp.photo = resourceId;
      },
      save(){
        return request({
          method: 'post',
          url: '/web/service?method=tCoreUser_edit',
          params: this.temp
        }).then((response) =>{
          if (response.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.dialogVisible = false
                this.$emit("getUserInfo")
              }
            })
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      back(){
        this.dialogVisible = false;
      },
      //重置
      resetTemp() {
        this.temp.id = '';
        this.temp.userName = '';
        this.temp.mobile = '';
        this.temp.email = '';
        this.temp.electronicSignature = '';
        this.temp.photo = '';
        this.temp.phStaffCode = '';
        this.temp.phStaffName = '';
        this.temp.phTeamCode = '';
        this.temp.phTeamName = '';
        this.$nextTick(() => {      //清空校验
          this.$refs['dataForm'].clearValidate()
        })
      },
      //选择家医
      selectTeamUser(item) {
        this.temp.phStaffCode = item.staffCode
        this.temp.phStaffName = item.staffName
        this.temp.phTeamCode = item.teamId
        this.temp.phTeamName = item.teamName

      },
      cleanTeamUser(){
        this.temp.phStaffCode = ''
        this.temp.phStaffName = ''
        this.temp.phTeamCode = ''
        this.temp.phTeamName = ''
      },
      handleTempUserOpen() {
        this.isTeamUserSelectShow = true;
        this.$nextTick(()=>{
          this.$refs.teamUserSelect.init();
        })

      },
       handleVerifyClick() {
          this.showVerifyForm = true;
      },
       submitVerify() {
          if (!this.verifyForm.phAccount || !this.verifyForm.phPassword) {
            this.$message.warning('请输入公卫账号和密码');
            return;
          }
      }

    }
  }
</script>




// WEBPACK FOOTER //
// src/components/HeaderPageBaseInfo.vue